import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
})

// Add authorization token to all requests
api.interceptors.request.use((config) => {
    // Check for seller token first (for seller/queue endpoints), then fallback to user token
    const sellerToken = localStorage.getItem('seller-tk');
    const userToken = localStorage.getItem('loginInfo');
    const token = sellerToken || (userToken ? JSON.parse(userToken) : null);
    
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
})

export default api;